import React, { useContext } from 'react'
import { Box, Typography, Divider } from '@mui/material'
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings'
import { searchContext } from '../Context/Context'

const HeadTable = () => {
  const { setChecked } = useContext(searchContext)

  const handleChecked = () => {
    setChecked((prev) => !prev)
  }
  return (
    <div style={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '& svg': {
            m: 1.5,
          },
        }}
      >
        <div>
          <Typography variant='h5' color='initial' sx={{ p: 2 }}>
            Ayaka
          </Typography>
        </div>
        <Divider orientation='vertical' flexItem sx={{ mr: 'auto', ml: 8 }} />

        <div>
          <DisplaySettingsIcon
            onClick={handleChecked}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </Box>
    </div>
  )
}

export default HeadTable
